import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, QUIZ_ALL, QUIZ_BY_ID, QUIZ_CACHE_ALL, QUIZ_LIST, QUIZ_TYPES } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const QUIZ_ASSESSMENT = GLOBAL_STATE

export const { reducer: quizReducer } = createSlice({
  name: QUIZ_ASSESSMENT,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.quizById.pending, state => {
        state[QUIZ_BY_ID].loading = true
      })
      .addCase(actionCreators.quizById.rejected, (state, action) => {
        state[QUIZ_BY_ID].loading = false
        state[QUIZ_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.quizById.fulfilled, (state, action) => {
        state[QUIZ_BY_ID].loading = false
        state[QUIZ_BY_ID].error = null
        state[QUIZ_BY_ID].data = action.payload
      })

    builder
      .addCase(actionCreators.quizAll.pending, state => {
        state[QUIZ_ALL].loading = true
      })
      .addCase(actionCreators.quizAll.rejected, (state, action) => {
        state[QUIZ_ALL].loading = false
        state[QUIZ_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.quizAll.fulfilled, (state, action) => {
        state[QUIZ_ALL].loading = false
        state[QUIZ_ALL].error = null
        state[QUIZ_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.quizCacheAll.pending, state => {
        state[QUIZ_CACHE_ALL].loading = true
      })
      .addCase(actionCreators.quizCacheAll.rejected, (state, action) => {
        state[QUIZ_CACHE_ALL].loading = false
        state[QUIZ_CACHE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.quizCacheAll.fulfilled, (state, action) => {
        state[QUIZ_CACHE_ALL].loading = false
        state[QUIZ_CACHE_ALL].error = null
        state[QUIZ_CACHE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.quizList.pending, state => {
        state[QUIZ_LIST].loading = true
      })
      .addCase(actionCreators.quizList.rejected, (state, action) => {
        state[QUIZ_LIST].loading = false
        state[QUIZ_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.quizList.fulfilled, (state, action) => {
        state[QUIZ_LIST].loading = false
        state[QUIZ_LIST].error = null
        state[QUIZ_LIST].data = action.payload
      })

    // builder
    //   .addCase(actionCreators.quizResults.pending, state => {
    //     state[QUIZ_RESULTS].loading = true
    //   })
    //   .addCase(actionCreators.quizResults.rejected, (state, action) => {
    //     state[QUIZ_RESULTS].loading = false
    //     state[QUIZ_RESULTS].error = action.payload as AxiosError
    //   })
    //   .addCase(actionCreators.quizResults.fulfilled, (state, action) => {
    //     state[QUIZ_RESULTS].loading = false
    //     state[QUIZ_RESULTS].error = null
    //     state[QUIZ_RESULTS].data = action.payload
    //   })

    // builder
    //   .addCase(actionCreators.quizResultOpen.pending, state => {
    //     state[QUIZ_RESULT_OPEN].loading = true
    //   })
    //   .addCase(actionCreators.quizResultOpen.rejected, (state, action) => {
    //     state[QUIZ_RESULT_OPEN].loading = false
    //     state[QUIZ_RESULT_OPEN].error = action.payload as AxiosError
    //   })
    //   .addCase(actionCreators.quizResultOpen.fulfilled, (state, action) => {
    //     state[QUIZ_RESULT_OPEN].loading = false
    //     state[QUIZ_RESULT_OPEN].error = null
    //     state[QUIZ_RESULT_OPEN].data = action.payload
    //   })

    builder
      .addCase(actionCreators.quizTypes.pending, state => {
        state[QUIZ_TYPES].loading = true
      })
      .addCase(actionCreators.quizTypes.rejected, (state, action) => {
        state[QUIZ_TYPES].loading = false
        state[QUIZ_TYPES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.quizTypes.fulfilled, (state, action) => {
        state[QUIZ_TYPES].loading = false
        state[QUIZ_TYPES].error = null
        state[QUIZ_TYPES].data = action.payload
      })

    builder.addCase(actionCreators.quizByIdClear, state => {
      state[QUIZ_BY_ID] = defaultState()
    })

    builder.addCase(actionCreators.quizAllClear, state => {
      state[QUIZ_ALL] = defaultState()
    })

    builder.addCase(actionCreators.quizCacheAllClear, state => {
      state[QUIZ_CACHE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.quizListClear, state => {
      state[QUIZ_LIST] = defaultState()
    })

    // builder.addCase(actionCreators.quizResultsClear, state => {
    //   state[QUIZ_RESULTS] = defaultState()
    // })

    // builder.addCase(actionCreators.quizResultOpenClear, state => {
    //   state[QUIZ_RESULT_OPEN] = defaultState()
    // })

    builder.addCase(actionCreators.quizTypesClear, state => {
      state[QUIZ_TYPES] = defaultState()
    })
  },
})
